export default __webpack_public_path__ + "static/media/AccidentAndEmergency.8814a390.svg";